/* 6FT Club site enhancements: headline sheen, header search, search suggestions, footer payment row. */
(function () {
  'use strict';

  var SUGGEST_URL = '/search/suggest.json?resources[type]=product,collection&resources[limit]=4&resources[options][unavailable_products]=last&q=';
  var SEARCH_PLACEHOLDER = 'Search for Elevator Shoes';

  /* Popular searches link straight to the matching collection, so the page shows the intended items. */
  var KEYWORDS = [
    { label: 'Height Increase Insoles', url: '/collections/height-boost-insoles' },
    { label: 'Elevator Shoes', url: '/collections/all-shoes-legacy' },
    { label: 'Low Top Elevator Shoes', url: '/collections/2-inch-elevator-shoes' },
    { label: 'Chelsea Boots', url: '/collections/boots' },
    { label: 'Boots', url: '/collections/boots' }
  ];

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SEARCH_ICON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="M21 21 L16.65 16.65" stroke-linecap="round"></path></svg>';

  /* Headline sheen: a light sweep that repeats every 7 seconds while the heading is on screen. */
  function initSheen() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var nodes = document.querySelectorAll('main h1, main h2, #MainContent h1, #MainContent h2');
    if (!nodes.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        if (entry.isIntersecting) {
          if (!el.classList.contains('sheen-run')) {
            el.style.setProperty('--sheen-base', window.getComputedStyle(el).color);
            el.classList.add('sheen-run');
          }
        } else {
          el.classList.remove('sheen-run');
        }
      });
    }, { threshold: 0.6 });

    Array.prototype.forEach.call(nodes, function (el) {
      observer.observe(el);
    });
  }

  /* Footer: stretch the payment icons across the same width as the email signup, so both ends line up. */
  function initPaymentRow() {
    var row = document.querySelector('.site-footer__payments');
    var form = document.querySelector('.site-footer__newsletter');
    if (!row || !form) return;

    var sync = function () { row.style.width = form.offsetWidth + 'px'; };
    sync();
    if ('ResizeObserver' in window) {
      new ResizeObserver(sync).observe(form);
    } else {
      window.addEventListener('resize', sync);
    }
  }

  function sizedImage(url, width) {
    var u = String(url);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /* Search box: popular searches when empty, live product and collection matches while typing. */
  function setupInput(input) {
    if (input.getAttribute('data-suggest-ready')) return;
    input.setAttribute('data-suggest-ready', 'true');
    input.placeholder = SEARCH_PLACEHOLDER;

    var field = input.closest('.field') || input.parentNode;
    var panel = document.createElement('div');
    panel.className = 'search-suggest';
    panel.hidden = true;

    var keywords = document.createElement('div');
    keywords.className = 'search-suggest__keywords';
    var keywordTitle = document.createElement('p');
    keywordTitle.className = 'search-suggest__title';
    keywordTitle.textContent = 'Popular searches';
    var keywordList = document.createElement('ul');
    keywordList.className = 'search-suggest__list';
    KEYWORDS.forEach(function (keyword) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = keyword.url;
      link.textContent = keyword.label;
      item.appendChild(link);
      keywordList.appendChild(item);
    });
    keywords.appendChild(keywordTitle);
    keywords.appendChild(keywordList);

    var results = document.createElement('div');
    results.className = 'search-suggest__results';
    results.hidden = true;

    panel.appendChild(keywords);
    panel.appendChild(results);
    field.parentNode.insertBefore(panel, field.nextSibling);

    /* Keep focus in the input when a suggestion is pressed, so the click still registers. */
    panel.addEventListener('mousedown', function (event) { event.preventDefault(); });

    var timer = null;
    var requestId = 0;

    function addGroup(label, items) {
      var heading = document.createElement('p');
      heading.className = 'search-suggest__title';
      heading.textContent = label;
      results.appendChild(heading);

      var list = document.createElement('ul');
      list.className = 'search-suggest__items';
      items.forEach(function (item) {
        var li = document.createElement('li');
        var link = document.createElement('a');
        link.href = item.url;
        if (item.image) {
          var img = document.createElement('img');
          img.src = sizedImage(item.image, 96);
          img.alt = '';
          img.width = 40;
          img.height = 40;
          link.appendChild(img);
        }
        var text = document.createElement('span');
        text.className = 'search-suggest__text';
        var name = document.createElement('span');
        name.className = 'search-suggest__name';
        name.textContent = item.title;
        text.appendChild(name);
        if (item.meta) {
          var meta = document.createElement('span');
          meta.className = 'search-suggest__meta';
          meta.textContent = item.meta;
          text.appendChild(meta);
        }
        link.appendChild(text);
        li.appendChild(link);
        list.appendChild(li);
      });
      results.appendChild(list);
    }

    function renderResults(query, products, collections) {
      results.textContent = '';
      if (products.length) {
        addGroup('Products', products.slice(0, 4).map(function (p) {
          return { title: p.title, url: p.url, image: p.image, meta: p.price };
        }));
      }
      if (collections.length) {
        addGroup('Collections', collections.slice(0, 3).map(function (c) {
          return { title: c.title, url: c.url, image: c.image, meta: '' };
        }));
      }
      var all = document.createElement('a');
      all.className = 'search-suggest__all';
      all.href = '/search?q=' + encodeURIComponent(query);
      all.textContent = 'See all results for "' + query + '"';
      results.appendChild(all);
    }

    function fetchResults(query) {
      var id = ++requestId;
      if (!window.fetch) return;
      window.fetch(SUGGEST_URL + encodeURIComponent(query), { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (data) {
          if (id !== requestId) return;
          var found = (data && data.resources && data.resources.results) || {};
          renderResults(query, found.products || [], found.collections || []);
          results.hidden = false;
          panel.hidden = document.activeElement !== input;
        })
        .catch(function () {
          if (id !== requestId) return;
          results.hidden = true;
          panel.hidden = true;
        });
    }

    function update() {
      var query = input.value.trim();
      clearTimeout(timer);
      if (document.activeElement !== input) {
        panel.hidden = true;
        return;
      }
      if (query === '') {
        keywords.hidden = false;
        results.hidden = true;
        panel.hidden = false;
        return;
      }
      keywords.hidden = true;
      if (query.length < 2) {
        panel.hidden = true;
        return;
      }
      var hasResults = results.childNodes.length > 0;
      results.hidden = !hasResults;
      panel.hidden = !hasResults;
      timer = setTimeout(function () { fetchResults(query); }, 180);
    }

    input.addEventListener('focus', update);
    input.addEventListener('input', update);
    input.addEventListener('blur', function () { panel.hidden = true; });
  }

  function initSearch() {
    var inputs = document.querySelectorAll('form[action*="/search"] input[name="q"]');
    Array.prototype.forEach.call(inputs, setupInput);
  }

  /* Desktop header: a search box sits in the header bar itself, with suggestions dropping below it. */
  function initHeaderSearch() {
    var icons = document.querySelector('.site-header__icons');
    if (!icons || icons.querySelector('.header-search')) return;

    var wrap = document.createElement('div');
    wrap.className = 'header-search';
    var form = document.createElement('form');
    form.action = '/search';
    form.method = 'get';
    form.setAttribute('role', 'search');
    form.className = 'header-search__form';

    var input = document.createElement('input');
    input.type = 'search';
    input.name = 'q';
    input.className = 'header-search__input';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-label', 'Search the store');

    var submit = document.createElement('button');
    submit.type = 'submit';
    submit.className = 'header-search__submit';
    submit.setAttribute('aria-label', 'Search');
    submit.innerHTML = SEARCH_ICON;

    form.appendChild(input);
    form.appendChild(submit);
    wrap.appendChild(form);
    icons.insertBefore(wrap, icons.firstChild);

    setupInput(input);
  }

  /* Phones and tablets: the magnifier opens a search panel under the header instead of leaving for /search. */
  function initSiteSearch() {
    var toggles = document.querySelectorAll('.site-header__icons a[aria-label="Search"]');
    var header = document.getElementById('site-header') || document.querySelector('.site-header');
    if (!toggles.length || !header) return;
    var toggleList = Array.prototype.slice.call(toggles);

    var panel = document.createElement('div');
    panel.className = 'site-search';
    panel.hidden = true;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Search');

    var inner = document.createElement('div');
    inner.className = 'site-search__inner';
    var form = document.createElement('form');
    form.action = '/search';
    form.method = 'get';
    form.setAttribute('role', 'search');
    form.className = 'site-search__form';

    var wrap = document.createElement('div');
    wrap.className = 'site-search__field';
    var input = document.createElement('input');
    input.type = 'search';
    input.name = 'q';
    input.id = 'site-search-input';
    input.className = 'site-search__input';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-label', 'Search the store');
    var closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'site-search__close';
    closeButton.setAttribute('aria-label', 'Close search');
    closeButton.textContent = '×';

    wrap.appendChild(input);
    wrap.appendChild(closeButton);
    form.appendChild(wrap);
    inner.appendChild(form);
    panel.appendChild(inner);
    document.body.appendChild(panel);

    setupInput(input);

    function place() {
      var rect = header.getBoundingClientRect();
      panel.style.top = Math.max(0, rect.bottom) + 'px';
    }

    function setExpanded(value) {
      toggleList.forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', value ? 'true' : 'false');
      });
    }

    function openSearch() {
      place();
      panel.hidden = false;
      setExpanded(true);
      input.focus();
    }

    function closeSearch() {
      panel.hidden = true;
      setExpanded(false);
    }

    setExpanded(false);
    toggleList.forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
        event.preventDefault();
        if (panel.hidden) {
          openSearch();
        } else {
          closeSearch();
        }
      });
    });

    closeButton.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) closeSearch();
    });

    document.addEventListener('pointerdown', function (event) {
      if (panel.hidden || panel.contains(event.target)) return;
      var onToggle = toggleList.some(function (toggle) { return toggle.contains(event.target); });
      if (!onToggle) closeSearch();
    });

    window.addEventListener('scroll', function () { if (!panel.hidden) place(); }, { passive: true });
    window.addEventListener('resize', function () { if (!panel.hidden) place(); });
  }

  /* Sold-out sizes stay clickable so a back-in-stock form (Klaviyo) can appear for that size.
     Add to cart stays disabled for them, because product.js only enables it for available sizes. */
  function initSoldOutSizes() {
    var buttons = document.querySelectorAll('.pdp-size-btn[disabled]');
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.removeAttribute('disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-sold-out');
      btn.style.opacity = '0.4';
      btn.style.cursor = 'pointer';
    });
    var options = document.querySelectorAll('[data-pdp-sticky-size] option[disabled][value]:not([value=""])');
    Array.prototype.forEach.call(options, function (opt) {
      opt.removeAttribute('disabled');
    });
  }

  function init() {
    initSearch();
    initHeaderSearch();
    initSiteSearch();
    initSheen();
    initPaymentRow();
    initSoldOutSizes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
